let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2cRXK")).then(() => parcelRequire('9DjR1'));